import { Input, OnDestroy, OnChanges, SimpleChanges, AfterViewInit, Directive } from '@angular/core';
import { Subscription } from 'rxjs';

import { Status } from '@df/core/status';
import { AppBusyStateBroadcasterComponentDef } from '@df/ui/display/busy-state/app-busy-state-broadcaster.component.def';

@Directive()
export abstract class StatusAppBusyStateComponentDef
    extends AppBusyStateBroadcasterComponentDef
    implements OnDestroy, OnChanges, AfterViewInit
{
    @Input({
        required: true
    })
    status!: Status;

    protected statusSubscription?: Subscription;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['status']) {
            this.clearSubscription();
            this.setSubscription();
            this.onStatusChange();
        }
    }

    override ngAfterViewInit() {
        super.ngAfterViewInit();
        this.onStatusChange();
    }

    ngOnDestroy() {
        this.clearSubscription();
        this.hide();
    }

    protected clearSubscription(): void {
        if (this.statusSubscription) {
            this.statusSubscription.unsubscribe();
        }
        this.hide();
    }

    protected setSubscription(): void {
        if (this.status) {
            this.statusSubscription = this.status.subscribe(() => this.onStatusChange());
        }
    }

    protected onStatusChange(): void {
        switch (true) {
            case this.status?.busy:
                this.show();
                break;
            case !this.status?.busy:
                this.hide();
                break;
        }
    }
}
